<template>
  <div id="app">
    <the-header>
      <lang-switch class="header-lang" />
    </the-header>
    <router-view />
    <the-footer />
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import LangSwitch from '@/components/LangSwitch.vue'
import {getMenus, getProductMenu} from '@/api/menu'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    LangSwitch
  },
  async created() {
    // 注册全局路由守卫
    this.$router.beforeEach((to, from, next) => {
      next();
    });
  },
  methods: {
  }
}
</script>

<style lang="less">
// 全局变量
.el-message{
  font-size: 40px !important;
}
@primary-color: #1890ff;
@text-color: #333;
@font-family:'AlibabaPuHuiTi', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

// 重置样式
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, 
body {
  width: 100%;
  overflow-x: hidden;
}
input, textarea {
  font-size: 16px !important; /* 设置字体大小为16px及以上 */
}
::-webkit-input-placeholder { /* WebKit browsers */

  color:#999;font-size:12px;

}

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */

  color:#999;font-size:12px;

}

::-moz-placeholder { /* Mozilla Firefox 19+ */

  color:#999;font-size:12px;

}

:-ms-input-placeholder { /* Internet Explorer 10+ */

  color:#999;font-size:12px;

}

// 全局样式
#app {
  font-family: @font-family;
  color: @text-color;
}

// ========== 公共布局样式 ==========
.container {
  max-width: 328px;
  margin: 0 auto;
  padding: 0;
}

.page-header {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
  height: 262px;
  .header-bg {
    position: absolute;
    background-color: rgba(18 , 55 , 105 , .6) !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .page-title {
    position: relative;
    font-size: 28px;
    color: #fff;
    margin-bottom: 2px;
    z-index: 2;
    padding-top: 50px;
  }

  .page-subtitle {
    position: relative;
    color: #fff;
    font-size: 16px;
    line-height: 1.6;
    opacity: 0.8;
    z-index: 2;
  }
}

.shop-right {
  cursor: pointer;
}

// ========== 公共标题样式 ==========
.section-title {
  font-weight: 600;
  font-size: 20px;
  color: var(--primary-color);
  line-height: 28px;
  position: relative;
  margin-bottom: 30px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 82px;
    height: 3px;
    background: linear-gradient( 270deg,rgba(226, 110, 118, 0) 0%, rgba(226, 110, 118, .2) 35%, #19529F 100%);
  }
  
  // 白色标题变体
  &--white {
    color: #fff;
    
    &::after {
      background: linear-gradient( 270deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
    }
  }
  
  // 小尺寸变体
  &--small {
    font-size: 32px;
    line-height: 45px;
  }
  
  // 中等尺寸变体
  &--medium {
    font-size: 40px;
    line-height: 56px;
  }
}

// ========== 公共按钮样式 ==========
.btn {
  display: inline-block;
  padding: 7px 15px;
  font-size: 20px;
  text-decoration: none;
  border-radius: 2px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  
  // 主要按钮
  &--primary {
    background: linear-gradient( 308deg, #E26E76 0%, #19529F 100%);
    color: #fff;
    border: 1px solid #19529F;
    
    &:hover {
      background: darken(#26549C, 10%);
      color: #fff;
    }
  }
  
  // 次要按钮
  &--secondary {
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.5);
    color: #fff;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
  
  // 圆角按钮
  &--rounded {
    border-radius: 24px;
    font-size: 16px;
    padding: 0 30px;
    height: 48px;
    line-height: 48px;
  }
}

// 更多按钮样式（兼容旧类名）
.more-btn,
.view-more-btn,
.learn-more-btn {
  @extend .btn;
  @extend .btn--primary;
}

// ========== 公共卡片样式 ==========
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  &--large {
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
}

// ========== 公共文本样式 ==========
.text-content {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
  line-height: 35px;
  text-align: justify;
  margin-bottom: 40px;
  
  p {
    margin-bottom: 10px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  &--small {
    font-size: 16px;
    line-height: 28px;
  }
  
  &--large {
    font-size: 24px;
    line-height: 42px;
  }
}

// ========== 公共图片样式 ==========
.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.img-responsive {
  width: 100%;
  height: auto;
}

// ========== 公共布局工具类 ==========
.section {
  padding: 60px 0;
  
  &--gray {
    background-color: #f5f5f5;
  }
  
  &--white {
    background-color: #fff;
  }
}

.flex {
  display: flex;
  
  &--center {
    align-items: center;
    justify-content: center;
  }
  
  &--between {
    justify-content: space-between;
  }
  
  &--column {
    flex-direction: column;
  }
}

.grid {
  display: grid;
  
  &--3 {
    grid-template-columns: repeat(3, 1fr);
  }
  
  &--auto-fit {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

// ========== 公共动画样式 ==========
.fade-in {
  opacity: 0;
  animation: fadeIn 0.6s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.slide-up {
  transform: translateY(30px);
  opacity: 0;
  animation: slideUp 0.6s ease forwards;
}

@keyframes slideUp {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

// ========== 公共响应式样式 ==========
@media (max-width: 768px) {
  
  .text-content {
    font-size: 16px;
    line-height: 28px;
  }
  
  .btn {
    font-size: 14px;
    padding: 12px 24px;
  }
  
  .flex {
    &--mobile-column {
      flex-direction: column;
    }
  }
  
  .grid {
    &--3 {
      grid-template-columns: 1fr;
    }
  }
}

// ========== 公共分页器样式 ==========

.swiper-navigation {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 30px;
  margin: 42px auto 0 auto;

  .swiper-navigation-btn{
    position: absolute;
    right: 20px;
    display: flex;

    &::before{
      content: '';
      position: absolute;
      width: calc( 100vw - 200px);
      height: 0;
      border-top: 1px solid;
      border-image: linear-gradient(270deg, rgba(25, 82, 159, 1), rgba(226, 110, 118, 0.13)) 1 1;
      left: calc( (100vw - 190px) * -1 );
      top: 50%;
      margin-top: -1px;
    }

    .swiper-button-prev,
    .swiper-button-next {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
      margin: 0;
      width: 60px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 30px;
      cursor: pointer;
      img{
        width: 14px;
        height: 11px;
      }
      &:after {
        display: none;
      }
      transition: all 0.3s ease;
    }

    .swiper-button-prev {
      background: #FFFFFF;
      box-shadow: 0 1px 9px 0 rgba(50,85,117,0.18);

      &:hover {
        background: #f5f5f5;
      }
    }

    .swiper-button-next {
      margin-left: 4px;
      background: #19529F;
      box-shadow: 0 2px 17px 2px rgba(60, 92, 167, 0.5);

      &:hover {
        background: #1a62c0;
      }
    }
  }
}

// ========== 公共滚动条样式 ==========
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #19529F #eee;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #19529F;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #eee;
  }
}

// ========== 公共悬停效果 ==========
.hover-lift {
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
}

.hover-scale {
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
}

// ========== 公共颜色变量 ==========
:root {
  --primary-color: #19529F;
  --secondary-color: #E26E76;
  --text-primary: #333;
  --text-secondary: #7A7A7A;
  --text-light: #757575;
  --bg-light: #f5f5f5;
  --border-color: #E1E4E6;
  --shadow-light: rgba(0, 0, 0, 0.1);
  --shadow-medium: rgba(0, 0, 0, 0.15);
}

.header-lang {
  margin-left: 20px;
}
//英译处理
.en-p {
  text-align: left !important;
}

</style>
